export default __webpack_public_path__ + "static/media/Omelchuk_Andrey_Vladimirovich.313310d3.webp";